import {
    apiRequest,
    pencantumanGelarDetail
} from "../../../../../services/adapters/kepegawaian/pencantumanGelarService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", pencantumanGelarDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository